import {NgModule} from '@angular/core';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {CollapseModule, TooltipModule} from 'ngx-bootstrap';
import {SharedModule} from '../shared/shared.module';
import {BrcChartComponent} from './brc-chart.component';
import {DashboardClientComponent} from './dashboard-client.component';
import {DashboardEmployeeComponent} from './dashboard-employee.component';
import {DashboardComponent} from './dashboard.component';
import {AgmCoreModule} from '@agm/core';
import {environment} from '../../../environments/environment';
import {BrcAdvancedLegendComponent} from './brc-advanced-legend.component';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardClientComponent,
    DashboardEmployeeComponent,
    BrcChartComponent,
    BrcAdvancedLegendComponent,
  ],
  exports: [
    DashboardComponent,
    BrcChartComponent,
    BrcAdvancedLegendComponent,
  ],
  imports: [
    SharedModule,
    CollapseModule.forRoot(),
    TooltipModule.forRoot(),
    NgxChartsModule,
    AgmCoreModule.forRoot({
      apiKey: environment.google.apiKey
    })
  ]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/dashboard/dashboard.module.ts